import { useMutation, useQueryClient } from "@tanstack/react-query";

import { postAddress } from "@/api/address";
import { AddressData } from "@/api/address/types";
import { PROFILE_QUERY_KEY } from "@/hooks/profile";
import { TServerError } from "@/types/api/shared";
import { User } from "@/types/api/user";

export function useUpdateAddress() {
  const queryClient = useQueryClient();

  return useMutation<User, TServerError, AddressData>({
    mutationFn: (body: AddressData) => postAddress(body),
    onSuccess: (data) => {
      queryClient.setQueryData([PROFILE_QUERY_KEY], data);
    },
  });
}
